import React, { useEffect, useRef, useState } from 'react';
import { preloadAssets } from '../../utils/AddressableManager';

export const satelliteAssets = [
  { type: 'gltf', key: 'iss', url: '/models/iss/issb.glb' },
  { type: 'gltf', key: 'hubble', url: '/models/telescopes/hubble.glb' },
  { type: 'gltf', key: 'jwst', url: '/models/telescopes/jwst.glb' },
  { type: 'geometry', key: 'satellite', url: 'sphere:0.05,16,16' },
];

// export const issAssets = [
//   // { type: 'gltf', key: 'issc', url: '/models/iss/newgltf/issc_simple.gltf' },
//   { type: 'gltf', key: 'issc', url: '/models/iss/issc_simple.glb' },
// ];

export const issAssets = [
  { type: 'gltf', key: 'issp1', url: '/models/iss/newgltf/issc_p1.gltf' },
  { type: 'gltf', key: 'issp2', url: '/models/iss/newgltf/issc_p2.gltf' },
  { type: 'gltf', key: 'issp3', url: '/models/iss/newgltf/issc_p3.gltf' },
  { type: 'gltf', key: 'issp4', url: '/models/iss/newgltf/issc_p4.gltf' },
  { type: 'gltf', key: 'issp5', url: '/models/iss/newgltf/issc_p5.gltf' },
  { type: 'gltf', key: 'issp6', url: '/models/iss/newgltf/issc_p6.gltf' },
  { type: 'gltf', key: 'issp7', url: '/models/iss/newgltf/issc_p7.gltf' },
  { type: 'gltf', key: 'issp8', url: '/models/iss/newgltf/issc_p8.gltf' },
  { type: 'gltf', key: 'issp9', url: '/models/iss/newgltf/issc_p9.gltf' },
  // { type: 'gltf', key: 'issp10', url: '/models/iss/newgltf/issc_p10.gltf' },
  // { type: 'gltf', key: 'issp11', url: '/models/iss/newgltf/issc_p11.gltf' },
  // { type: 'gltf', key: 'issp12', url: '/models/iss/newgltf/issc_p12.gltf' },
  // { type: 'gltf', key: 'issp13', url: '/models/iss/newgltf/issc_p13.gltf' },
  // { type: 'gltf', key: 'issp14', url: '/models/iss/newgltf/issc_p14.gltf' },
  // { type: 'gltf', key: 'issp15', url: '/models/iss/newgltf/issc_p15.gltf' },
  // { type: 'gltf', key: 'issp16', url: '/models/iss/newgltf/issc_p16.gltf' },
  // { type: 'gltf', key: 'issp17', url: '/models/iss/newgltf/issc_p17.gltf' },
];



// export const issAssets = [
//   { type: 'gltf', key: 'issairlock', url: '/models/iss/newgltf/issc_airlock.gltf' },
//   { type: 'gltf', key: 'issams', url: '/models/iss/newgltf/issc_ams.gltf' },
//   { type: 'gltf', key: 'issbeam', url: '/models/iss/newgltf/issc_beam.gltf' },
//   { type: 'gltf', key: 'issbishopairlock', url: '/models/iss/newgltf/issc_bishop_airlock.gltf' },

//   { type: 'gltf', key: 'isscolumbus', url: '/models/iss/newgltf/issc_columbus.gltf' },
//   { type: 'gltf', key: 'isscolumbusp2', url: '/models/iss/newgltf/issc_columbusp2.gltf' },

//   { type: 'gltf', key: 'isscupola', url: '/models/iss/newgltf/issc_cupola.gltf' },
//   { type: 'gltf', key: 'isscupolap2', url: '/models/iss/newgltf/issc_cupolap2.gltf' },

//   { type: 'gltf', key: 'issecla1', url: '/models/iss/newgltf/issc_ecla1.gltf' },
//   { type: 'gltf', key: 'issecla1p2', url: '/models/iss/newgltf/issc_ecla1p2.gltf' },
//   { type: 'gltf', key: 'issecla1p3', url: '/models/iss/newgltf/issc_ecla1p3.gltf' },
//   { type: 'gltf', key: 'issecla1p4', url: '/models/iss/newgltf/issc_ecla1p4.gltf' },
//   { type: 'gltf', key: 'issecla1p5', url: '/models/iss/newgltf/issc_ecla1p5.gltf' },
//   { type: 'gltf', key: 'issecla1p6', url: '/models/iss/newgltf/issc_ecla1p6.gltf' },

//   { type: 'gltf', key: 'issecla2', url: '/models/iss/newgltf/issc_ecla2.gltf' },
//   { type: 'gltf', key: 'issecla2p2', url: '/models/iss/newgltf/issc_ecla2p2.gltf' },
//   { type: 'gltf', key: 'issecla2p3', url: '/models/iss/newgltf/issc_ecla2p3.gltf' },
//   { type: 'gltf', key: 'issecla2p4', url: '/models/iss/newgltf/issc_ecla2p4.gltf' },
//   { type: 'gltf', key: 'issecla2p5', url: '/models/iss/newgltf/issc_ecla2p5.gltf' },

//   { type: 'gltf', key: 'issecla3', url: '/models/iss/newgltf/issc_ecla3.gltf' },
//   { type: 'gltf', key: 'issecla3p2', url: '/models/iss/newgltf/issc_ecla3p2.gltf' },
//   { type: 'gltf', key: 'issecla3p3', url: '/models/iss/newgltf/issc_ecla3p3.gltf' },
//   { type: 'gltf', key: 'issecla3p4', url: '/models/iss/newgltf/issc_ecla3p4.gltf' },
//   { type: 'gltf', key: 'issecla3p5', url: '/models/iss/newgltf/issc_ecla3p5.gltf' },
//   { type: 'gltf', key: 'issecla3p6', url: '/models/iss/newgltf/issc_ecla3p6.gltf' },

//   { type: 'gltf', key: 'issecla4', url: '/models/iss/newgltf/issc_ecla4.gltf' },
//   { type: 'gltf', key: 'issecla4p2', url: '/models/iss/newgltf/issc_ecla4p2.gltf' },
//   { type: 'gltf', key: 'issecla4p3', url: '/models/iss/newgltf/issc_ecla4p3.gltf' },
//   { type: 'gltf', key: 'issecla4p4', url: '/models/iss/newgltf/issc_ecla4p4.gltf' },

//   { type: 'gltf', key: 'issesp1', url: '/models/iss/newgltf/issc_esp1.gltf' },

//   { type: 'gltf', key: 'issesp2', url: '/models/iss/newgltf/issc_esp2.gltf' },
//   { type: 'gltf', key: 'issesp2p2', url: '/models/iss/newgltf/issc_esp2p2.gltf' },
//   { type: 'gltf', key: 'issesp2p3', url: '/models/iss/newgltf/issc_esp2p3.gltf' },
//   { type: 'gltf', key: 'issesp2p4', url: '/models/iss/newgltf/issc_esp2p4.gltf' },
//   { type: 'gltf', key: 'issesp2p5', url: '/models/iss/newgltf/issc_esp2p5.gltf' },

//   { type: 'gltf', key: 'issesp3', url: '/models/iss/newgltf/issc_esp3.gltf' },
//   { type: 'gltf', key: 'issesp3p2', url: '/models/iss/newgltf/issc_esp3p2.gltf' },
//   { type: 'gltf', key: 'issesp3p3', url: '/models/iss/newgltf/issc_esp3p3.gltf' },
//   { type: 'gltf', key: 'issesp3p4', url: '/models/iss/newgltf/issc_esp3p4.gltf' },

//   { type: 'gltf', key: 'issjemef', url: '/models/iss/newgltf/issc_jem_ef.gltf' },
//   { type: 'gltf', key: 'issjemefp2', url: '/models/iss/newgltf/issc_jem_efp2.gltf' },
//   { type: 'gltf', key: 'issjemefp3', url: '/models/iss/newgltf/issc_jem_efp3.gltf' },
//   { type: 'gltf', key: 'issjemefp4', url: '/models/iss/newgltf/issc_jem_efp4.gltf' },
//   { type: 'gltf', key: 'issjemefp5', url: '/models/iss/newgltf/issc_jem_efp5.gltf' },
//   { type: 'gltf', key: 'issjemefp6', url: '/models/iss/newgltf/issc_jem_efp6.gltf' },
//   { type: 'gltf', key: 'issjemefp7', url: '/models/iss/newgltf/issc_jem_efp7.gltf' },
//   { type: 'gltf', key: 'issjemefp8', url: '/models/iss/newgltf/issc_jem_efp8.gltf' },

//   { type: 'gltf', key: 'issjempm', url: '/models/iss/newgltf/issc_jem_pm.gltf' },
//   { type: 'gltf', key: 'issjempmp2', url: '/models/iss/newgltf/issc_jem_pmp2.gltf' },

//   { type: 'gltf', key: 'issjemps', url: '/models/iss/newgltf/issc_jem_ps.gltf' },

//   { type: 'gltf', key: 'issmlm', url: '/models/iss/newgltf/issc_mlm.gltf' },

//   { type: 'gltf', key: 'issmrm1', url: '/models/iss/newgltf/issc_mrm1.gltf' },
//   { type: 'gltf', key: 'issmrm2', url: '/models/iss/newgltf/issc_mrm2.gltf' },

//   { type: 'gltf', key: 'issmtlocation', url: '/models/iss/newgltf/issc_mt_location.gltf' },

//   { type: 'gltf', key: 'issnode1', url: '/models/iss/newgltf/issc_node1.gltf' },
//   { type: 'gltf', key: 'issnode2', url: '/models/iss/newgltf/issc_node2.gltf' },
//   { type: 'gltf', key: 'issnode3', url: '/models/iss/newgltf/issc_node3.gltf' },

//   { type: 'gltf', key: 'isspma1', url: '/models/iss/newgltf/issc_pma1.gltf' },
//   { type: 'gltf', key: 'isspma2', url: '/models/iss/newgltf/issc_pma2.gltf' },
//   { type: 'gltf', key: 'isspma3', url: '/models/iss/newgltf/issc_pma3.gltf' },
//   { type: 'gltf', key: 'isspmm', url: '/models/iss/newgltf/issc_pmm.gltf' },

//   { type: 'gltf', key: 'issportalpharot', url: '/models/iss/newgltf/issc_port_alpha_rot.gltf' },
//   { type: 'gltf', key: 'issportalpharotp2', url: '/models/iss/newgltf/issc_port_alpha_rotp2.gltf' },
//   { type: 'gltf', key: 'issportalpharotp3', url: '/models/iss/newgltf/issc_port_alpha_rotp3.gltf' },

//   { type: 'gltf', key: 'issrussianrsnodedockingmodule', url: '/models/iss/newgltf/issc_russian_rsnode_dockingmodule.gltf' },

//   { type: 'gltf', key: 'isscspdmleebase', url: '/models/iss/newgltf/issc_spdm_lee_base.gltf' },
//   { type: 'gltf', key: 'isscssrmsbase', url: '/models/iss/newgltf/issc_ssrms_base.gltf' },

//   { type: 'gltf', key: 'isscstbdalpharot', url: '/models/iss/newgltf/issc_stbd_alpha_rot.gltf' },
//   { type: 'gltf', key: 'isscstbdalpharotp2', url: '/models/iss/newgltf/issc_stbd_alpha_rotp2.gltf' },
//   { type: 'gltf', key: 'isscstbdalpharotp3', url: '/models/iss/newgltf/issc_stbd_alpha_rotp3.gltf' },
//   { type: 'gltf', key: 'isscstbdalpharotp4', url: '/models/iss/newgltf/issc_stbd_alpha_rotp4.gltf' },

//   { type: 'gltf', key: 'issctrussp1', url: '/models/iss/newgltf/issc_truss_p1.gltf' },
//   { type: 'gltf', key: 'issctrussp3', url: '/models/iss/newgltf/issc_truss_p3.gltf' },
//   { type: 'gltf', key: 'issctrusss0', url: '/models/iss/newgltf/issc_truss_s0.gltf' },
//   { type: 'gltf', key: 'issctrusss1', url: '/models/iss/newgltf/issc_truss_s1.gltf' },
//   { type: 'gltf', key: 'issctrusss3', url: '/models/iss/newgltf/issc_truss_s3.gltf' },

//   { type: 'gltf', key: 'isscuslab', url: '/models/iss/newgltf/issc_uslab.gltf' },

//   { type: 'gltf', key: 'isscz1', url: '/models/iss/newgltf/issc_z1.gltf' },
//   { type: 'gltf', key: 'issczaryafgb', url: '/models/iss/newgltf/issc_zarya_fgb.gltf' },
//   { type: 'gltf', key: 'issczvezdasm', url: '/models/iss/newgltf/issc_zvezda_sm.gltf' },
// ];



// export const issTextures = [
//   { type: 'texture', key: 'isscairlockdiffuse', url: '/models/iss/newgltf/Airlock_diffuse.ktx2' },
//   { type: 'texture', key: 'isscairlocknormal', url: '/models/iss/newgltf/Airlock_Normal.ktx2' },

// ];
// Silent asset (not part of progress)
// export const issAssets = [
//   { type: 'gltf', key: 'issairlock', url: '/models/iss/issc_airlock.glb' },
//   { type: 'gltf', key: 'issams', url: '/models/iss/issc_ams.glb' },
//   { type: 'gltf', key: 'issbeam', url: '/models/iss/issc_beam.glb' },
//   { type: 'gltf', key: 'issbishopairlock', url: '/models/iss/issc_bishop_airlock.glb' },

//   { type: 'gltf', key: 'isscolumbus', url: '/models/iss/issc_columbus.glb' },
//   { type: 'gltf', key: 'isscolumbusp2', url: '/models/iss/issc_columbusp2.glb' },

//   { type: 'gltf', key: 'isscupola', url: '/models/iss/issc_cupola.glb' },
//   { type: 'gltf', key: 'isscupolap2', url: '/models/iss/issc_cupolap2.glb' },

//   { type: 'gltf', key: 'issecla1', url: '/models/iss/issc_ecla1.glb' },
//   { type: 'gltf', key: 'issecla1p2', url: '/models/iss/issc_ecla1p2.glb' },
//   { type: 'gltf', key: 'issecla1p3', url: '/models/iss/issc_ecla1p3.glb' },
//   { type: 'gltf', key: 'issecla1p4', url: '/models/iss/issc_ecla1p4.glb' },
//   { type: 'gltf', key: 'issecla1p5', url: '/models/iss/issc_ecla1p5.glb' },
//   { type: 'gltf', key: 'issecla1p6', url: '/models/iss/issc_ecla1p6.glb' },

//   { type: 'gltf', key: 'issecla2', url: '/models/iss/issc_ecla2.glb' },
//   { type: 'gltf', key: 'issecla2p2', url: '/models/iss/issc_ecla2p2.glb' },
//   { type: 'gltf', key: 'issecla2p3', url: '/models/iss/issc_ecla2p3.glb' },
//   { type: 'gltf', key: 'issecla2p4', url: '/models/iss/issc_ecla2p4.glb' },
//   { type: 'gltf', key: 'issecla2p5', url: '/models/iss/issc_ecla2p5.glb' },

//   { type: 'gltf', key: 'issecla3', url: '/models/iss/issc_ecla3.glb' },
//   { type: 'gltf', key: 'issecla3p2', url: '/models/iss/issc_ecla3p2.glb' },
//   { type: 'gltf', key: 'issecla3p3', url: '/models/iss/issc_ecla3p3.glb' },
//   { type: 'gltf', key: 'issecla3p4', url: '/models/iss/issc_ecla3p4.glb' },
//   { type: 'gltf', key: 'issecla3p5', url: '/models/iss/issc_ecla3p5.glb' },
//   { type: 'gltf', key: 'issecla3p6', url: '/models/iss/issc_ecla3p6.glb' },

//   { type: 'gltf', key: 'issecla4', url: '/models/iss/issc_ecla4.glb' },
//   { type: 'gltf', key: 'issecla4p2', url: '/models/iss/issc_ecla4p2.glb' },
//   { type: 'gltf', key: 'issecla4p3', url: '/models/iss/issc_ecla4p3.glb' },
//   { type: 'gltf', key: 'issecla4p4', url: '/models/iss/issc_ecla4p4.glb' },

//   { type: 'gltf', key: 'issesp1', url: '/models/iss/issc_esp1.glb' },

//   { type: 'gltf', key: 'issesp2', url: '/models/iss/issc_esp2.glb' },
//   { type: 'gltf', key: 'issesp2p2', url: '/models/iss/issc_esp2p2.glb' },
//   { type: 'gltf', key: 'issesp2p3', url: '/models/iss/issc_esp2p3.glb' },
//   { type: 'gltf', key: 'issesp2p4', url: '/models/iss/issc_esp2p4.glb' },
//   { type: 'gltf', key: 'issesp2p5', url: '/models/iss/issc_esp2p5.glb' },

//   { type: 'gltf', key: 'issesp3', url: '/models/iss/issc_esp3.glb' },
//   { type: 'gltf', key: 'issesp3p2', url: '/models/iss/issc_esp3p2.glb' },
//   { type: 'gltf', key: 'issesp3p3', url: '/models/iss/issc_esp3p3.glb' },
//   { type: 'gltf', key: 'issesp3p4', url: '/models/iss/issc_esp3p4.glb' },

//   { type: 'gltf', key: 'issjemef', url: '/models/iss/issc_jem_ef.glb' },
//   { type: 'gltf', key: 'issjemefp2', url: '/models/iss/issc_jem_efp2.glb' },
//   { type: 'gltf', key: 'issjemefp3', url: '/models/iss/issc_jem_efp3.glb' },
//   { type: 'gltf', key: 'issjemefp4', url: '/models/iss/issc_jem_efp4.glb' },
//   { type: 'gltf', key: 'issjemefp5', url: '/models/iss/issc_jem_efp5.glb' },
//   { type: 'gltf', key: 'issjemefp6', url: '/models/iss/issc_jem_efp6.glb' },
//   { type: 'gltf', key: 'issjemefp7', url: '/models/iss/issc_jem_efp7.glb' },
//   { type: 'gltf', key: 'issjemefp8', url: '/models/iss/issc_jem_efp8.glb' },

//   { type: 'gltf', key: 'issjempm', url: '/models/iss/issc_jem_pm.glb' },
//   { type: 'gltf', key: 'issjempmp2', url: '/models/iss/issc_jem_pmp2.glb' },

//   { type: 'gltf', key: 'issjemps', url: '/models/iss/issc_jem_ps.glb' },

//   { type: 'gltf', key: 'issmlm', url: '/models/iss/issc_mlm.glb' },

//   { type: 'gltf', key: 'issmrm1', url: '/models/iss/issc_mrm1.glb' },
//   { type: 'gltf', key: 'issmrm2', url: '/models/iss/issc_mrm2.glb' },

//   { type: 'gltf', key: 'issmtlocation', url: '/models/iss/issc_mt_location.glb' },

//   { type: 'gltf', key: 'issnode1', url: '/models/iss/issc_node1.glb' },
//   { type: 'gltf', key: 'issnode2', url: '/models/iss/issc_node2.glb' },
//   { type: 'gltf', key: 'issnode3', url: '/models/iss/issc_node3.glb' },

//   { type: 'gltf', key: 'isspma1', url: '/models/iss/issc_pma1.glb' },
//   { type: 'gltf', key: 'isspma2', url: '/models/iss/issc_pma2.glb' },
//   { type: 'gltf', key: 'isspma3', url: '/models/iss/issc_pma3.glb' },
//   { type: 'gltf', key: 'isspmm', url: '/models/iss/issc_pmm.glb' },

//   { type: 'gltf', key: 'issportalpharot', url: '/models/iss/issc_port_alpha_rot.glb' },
//   { type: 'gltf', key: 'issportalpharotp2', url: '/models/iss/issc_port_alpha_rotp2.glb' },
//   { type: 'gltf', key: 'issportalpharotp3', url: '/models/iss/issc_port_alpha_rotp3.glb' },

//   { type: 'gltf', key: 'issrussianrsnodedockingmodule', url: '/models/iss/issc_russian_rsnode_dockingmodule.glb' },

//   { type: 'gltf', key: 'isscspdmleebase', url: '/models/iss/issc_spdm_lee_base.glb' },
//   { type: 'gltf', key: 'isscssrmsbase', url: '/models/iss/issc_ssrms_base.glb' },

//   { type: 'gltf', key: 'isscstbdalpharot', url: '/models/iss/issc_stbd_alpha_rot.glb' },
//   { type: 'gltf', key: 'isscstbdalpharotp2', url: '/models/iss/issc_stbd_alpha_rotp2.glb' },
//   { type: 'gltf', key: 'isscstbdalpharotp3', url: '/models/iss/issc_stbd_alpha_rotp3.glb' },
//   { type: 'gltf', key: 'isscstbdalpharotp4', url: '/models/iss/issc_stbd_alpha_rotp4.glb' },

//   { type: 'gltf', key: 'issctrussp1', url: '/models/iss/issc_truss_p1.glb' },
//   { type: 'gltf', key: 'issctrussp3', url: '/models/iss/issc_truss_p3.glb' },
//   { type: 'gltf', key: 'issctrusss0', url: '/models/iss/issc_truss_s0.glb' },
//   { type: 'gltf', key: 'issctrusss1', url: '/models/iss/issc_truss_s1.glb' },
//   { type: 'gltf', key: 'issctrusss3', url: '/models/iss/issc_truss_s3.glb' },

//   { type: 'gltf', key: 'isscuslab', url: '/models/iss/issc_uslab.glb' },

//   { type: 'gltf', key: 'isscz1', url: '/models/iss/issc_z1.glb' },
//   { type: 'gltf', key: 'issczaryafgb', url: '/models/iss/issc_zarya_fgb.glb' },
//   { type: 'gltf', key: 'issczvezdasm', url: '/models/iss/issc_zvezda_sm.glb' },
// ];

export default function SatellitePreloader({ onComplete, onProgress }) {
  const hasPreloaded = useRef(false);

  useEffect(() => {
    if (hasPreloaded.current) return;
    hasPreloaded.current = true;

    const mainAssetsToLoad = [...satelliteAssets];

    let totalAssets = mainAssetsToLoad.length;
    let loadedCount = 0;

    const handleProgress = () => {
      loadedCount++;
      const progress = Math.round((loadedCount / totalAssets) * 100);
      if (typeof onProgress === 'function') onProgress(progress);
    };

    // Start loading background asset immediately but silently
    // preloadAssets([backgroundAsset])
    //   .then((bgAssets) => {
    //     console.log('Background asset loaded (issc):', bgAssets.issc);
    //     // You can store or cache this silently
    //   })
    //   .catch((err) => {
    //     console.warn('Failed to load background asset (issc):', err);
    //   });

    // Load main assets with progress tracking
    preloadAssets(mainAssetsToLoad, handleProgress)
      .then((loadedAssets) => {
        const normalizedAssets = {};
        for (const [key, value] of Object.entries(loadedAssets)) {
          normalizedAssets[key.toLowerCase()] = value;
        }
        if (typeof onComplete === 'function') onComplete(normalizedAssets);
      })
      .catch((err) => {
        console.error('Error preloading assets:', err);
      });

  }, [onComplete, onProgress]);

  return null;
}


// /**
//  * Loads assets in batches to avoid overwhelming memory (especially on mobile).
//  * @param {Array} assets - List of asset descriptors { type, key, url }
//  * @param {number} chunkSize - Number of assets to load at once
//  * @param {Function} [onProgress] - Progress callback
//  * @returns {Promise<Object>} - Loaded asset map
//  */
// async function loadAssetsInChunks(assets, chunkSize = 1, onProgress) {
//   const total = assets.length;
//   let loaded = 0;
//   const result = {};

//   for (let i = 0; i < total; i += chunkSize) {
//     const chunk = assets.slice(i, i + chunkSize);

//     const chunkResult = await preloadAssets(chunk, () => {
//       loaded++;
//       if (typeof onProgress === 'function') {
//         const percent = Math.round((loaded / total) * 100);
//         onProgress(percent);
//       }
//     });

//     Object.assign(result, chunkResult);

//     // Optional: wait a bit between batches to let browser breathe
//     await new Promise((res) => setTimeout(res, 100));
//   }

//   return result;
// }

// export function ISSPreloader({ onComplete, onProgress }) {
//   const hasPreloaded = useRef(false);

//   useEffect(() => {
//     if (hasPreloaded.current) return;
//     hasPreloaded.current = true;

//     const assetsToLoad = [...issAssets];

//     loadAssetsInChunks(assetsToLoad, 1, onProgress)
//       .then((loadedAssets) => {
//         const normalizedAssets = {};
//         for (const [key, value] of Object.entries(loadedAssets)) {
//           normalizedAssets[key.toLowerCase()] = value;
//         }
//         if (typeof onComplete === 'function') {
//           onComplete(normalizedAssets);
//         }
//       })
//       .catch((err) => {
//         console.error('Error preloading ISS assets:', err);
//       });
//   }, [onComplete, onProgress]);

//   return null;
// }
/**
 * Loads assets in batches to avoid overwhelming memory (especially on mobile).
 * @param {Array} assets - List of asset descriptors { type, key, url }
 * @param {number} chunkSize - Number of assets to load at once
 * @param {Function} [onProgress] - Optional progress callback (receives percent loaded)
 * @returns {Promise<Object>} - Resolves to an object mapping keys to loaded assets
 */
async function loadAssetsInChunks(assets, chunkSize = 1, onProgress) {
  const total = assets.length;
  let loaded = 0;
  const result = {};

  for (let i = 0; i < total; i += chunkSize) {
    const chunk = assets.slice(i, i + chunkSize);

    const chunkResult = await preloadAssets(chunk);
    Object.assign(result, chunkResult);

    loaded += chunk.length;
    if (typeof onProgress === 'function') {
      onProgress(Math.round((loaded / total) * 100));
      console.log(Math.round((loaded / total) * 100));
    }

    await new Promise((res) => setTimeout(res, 100));
  }
  return result;
}

export function ISSPreloader({ onComplete, onProgress }) {
  const hasPreloaded = useRef(false);

  // const mainAssetsToLoad = [...issAssets, ...issTextures];
  const mainAssetsToLoad = [...issAssets];

  useEffect(() => {
    if (hasPreloaded.current) return;
    hasPreloaded.current = true;

    loadAssetsInChunks(mainAssetsToLoad, 2, onProgress)
      .then((loadedAssets) => {
        const normalizedAssets = {};
        for (const [key, value] of Object.entries(loadedAssets)) {
          normalizedAssets[key.toLowerCase()] = value;
        }
        if (typeof onComplete === 'function') onComplete(normalizedAssets);
      })
      .catch((err) => {
        console.error('Error preloading ISS assets:', err);
      });
  }, [onComplete, onProgress]);

  return null;
}
